{
  "pt": {
    "pagination": {
      "next": "Página seguinte",
      "page_report": "Página {page} de {total}",
      "previous": "Página anterior",
      "report": "A mostrar {first} a {last} de {total}",
      "total": "Total de itens: {total}"
    }
  }
}
